import {
  LICENSE_PRO_REQUEST_REQUEST,
  LICENSE_PRO_REQUEST_SUCCESS,
  LICENSE_PRO_REQUEST_FAILURE,
  LICENSE_PRO_REQUEST_RESET,
  FEATURE_ACTIVATION_REQUEST,
  FEATURE_ACTIVATION_SUCCESS,
  FEATURE_ACTIVATION_FAILURE,
  FEATURE_ACTIVATION_RESET,
} from '../actions/license'

const INITIAL_STATE = {
  loading: false,
  sent: false,
  error: null,
  featureLoading: false,
  featureSent: false,
  featureError: null,
}

const licenseReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LICENSE_PRO_REQUEST_REQUEST:
      return { ...state, loading: true, sent: false, error: null }
    case LICENSE_PRO_REQUEST_SUCCESS:
      return { ...state, loading: false, sent: true, error: null }
    case LICENSE_PRO_REQUEST_FAILURE:
      return { ...state, loading: false, sent: false, error: action.error }
    case LICENSE_PRO_REQUEST_RESET:
      return { ...state, loading: false, sent: false, error: null }
    case FEATURE_ACTIVATION_REQUEST:
      return { ...state, featureLoading: true, featureSent: false, featureError: null }
    case FEATURE_ACTIVATION_SUCCESS:
      return { ...state, featureLoading: false, featureSent: true, featureError: null }
    case FEATURE_ACTIVATION_FAILURE:
      return { ...state, featureLoading: false, featureSent: false, featureError: action.error }
    case FEATURE_ACTIVATION_RESET:
      return { ...state, featureLoading: false, featureSent: false, featureError: null }
    default:
      return state
  }
}

export default licenseReducer
